import { Colors } from "../../../../utils/colors";
import { Icon } from "@iconify/react";
import React, { CSSProperties, useCallback, useMemo, useState } from "react";
import {
  MARKIT_QUIET_HOURS,
  textTimeWithinQuietHours,
} from "@markit/common.utils";
import { ScheduleTextInfo } from "@markit/common.types";
import StandardBorderedContainer from "../../../Containers/StandardBorderedContainer";
import { useSelector } from "react-redux";
import { getAccountState } from "../../../../redux/slices/accountSlice";
import QuietHoursDisableModal from "./QuietHoursDisableModal";
import QuietHoursSendingModal from "./QuietHoursSendingModal";

type QuietHoursNoticeProps = {
  scheduleTextInfo: ScheduleTextInfo;
  setScheduleTextInfo: (ScheduleTextInfo: ScheduleTextInfo) => void;
  containerStyles?: CSSProperties;
};

const QuietHoursNotice = (props: QuietHoursNoticeProps) => {
  const { scheduleTextInfo, setScheduleTextInfo, containerStyles } = props;
  const bypassQuietHours =
    useSelector(getAccountState).account.accountData.bypassQuietHours;
  const [showDisableQuietHoursModal, setShowDisableQuietHoursModal] =
    useState(false);
  const [showSuggestedTimesModal, setShowSuggestedTimesModal] = useState(false);
  const [hideNotice, setHideNotice] = useState(false);

  const styles = {
    quietHoursContainer: {
      ...containerStyles,
      borderRadius: 12,
      padding: 14,
      backgroundColor: "rgba(255, 204, 0, 0.2)",
      border: `1px solid ${Colors.YELLOW1}`,
    },
  };

  const withinQuietHours = useMemo(
    () => textTimeWithinQuietHours(scheduleTextInfo),
    [scheduleTextInfo]
  );

  const learnMoreOnPress = useCallback(() => {
    window.open(MARKIT_QUIET_HOURS);
  }, []);

  return withinQuietHours && !hideNotice ? (
    <>
      <StandardBorderedContainer containerStyles={styles.quietHoursContainer}>
        <div className="AlignedRowSpaced" style={{ gap: 14 }}>
          <div className="AlignedRow" style={{ gap: 14 }}>
            <div>
              <Icon
                icon={bypassQuietHours ? "tabler:moon-off" : "ion:moon"}
                height={24}
                style={{ color: Colors.BLACK }}
              />
            </div>
            <div className="ColumnNormal" style={{ gap: 7 }}>
              <span className="bodyMedium">Quiet Hours</span>
              <span style={{ fontSize: 12 }}>
                Some locations only permit SMS marketing between 8:00am and
                7:30pm. Your send time may not comply with these restrictions.
                {bypassQuietHours
                  ? ""
                  : " Schedule your text or disable quiet hours to prevent potential disruptions."}
              </span>
              {bypassQuietHours ? (
                <>
                  <span style={{ fontSize: 12 }}>
                    <span style={{ fontWeight: 600 }}>Sending Enabled!</span>{" "}
                    Quiet Hours are turned{" "}
                    <span style={{ fontWeight: 600 }}>OFF</span>. You are clear
                    to send texts at this time.
                  </span>
                  <div
                    className="AlignedRowSelect"
                    onClick={learnMoreOnPress}
                    style={{ gap: 2 }}
                  >
                    <span style={{ fontSize: 12, fontWeight: 500 }}>
                      Learn More
                    </span>
                    <Icon icon="ion:chevron-right" height={14} />
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="AlignedRowSelect"
                    onClick={() => setShowSuggestedTimesModal(true)}
                    style={{ gap: 2 }}
                  >
                    <span style={{ fontSize: 12, fontWeight: 500 }}>
                      Suggested Send Times
                    </span>
                    <Icon icon="ion:chevron-right" height={14} />
                  </div>
                  <div
                    className="AlignedRowSelect"
                    onClick={() => setShowDisableQuietHoursModal(true)}
                    style={{ gap: 2 }}
                  >
                    <span style={{ fontSize: 12, fontWeight: 500 }}>
                      Disable Quiet Hours
                    </span>
                    <Icon icon="ion:chevron-right" height={14} />
                  </div>
                </>
              )}
            </div>
          </div>
          {bypassQuietHours ? (
            <div style={{ cursor: "pointer" }}>
              <Icon
                icon="ion:close"
                height={20}
                color={Colors.GRAY1}
                onClick={() => setHideNotice(true)}
              />
            </div>
          ) : null}
        </div>
      </StandardBorderedContainer>
      {showSuggestedTimesModal ? (
        <QuietHoursSendingModal
          scheduleTextInfo={scheduleTextInfo}
          setScheduleTextInfo={setScheduleTextInfo}
          setIsVisible={setShowSuggestedTimesModal}
        />
      ) : null}
      {showDisableQuietHoursModal ? (
        <QuietHoursDisableModal setIsVisible={setShowDisableQuietHoursModal} />
      ) : null}
    </>
  ) : null;
};

export default QuietHoursNotice;
